/* スマートフォンに、PC用画面を表示させる */
$(function() {
    $(".switch_screen").hide();
    $('.pc_screen').hide();
    $('.sp_screen').hide();

    $(".pc_screen").click(function(){
        $.cookie("switch_screen","pc",{path:'/'});
        url = location.href;
        location.href = url;
        return false;
    });

    $(".sp_screen").click(function(){
        $.cookie("switch_screen","sp",{path:'/'});
        url = location.href;
        location.href = url;
        return false;
    });

    if ( /iPhone|iPod|Android.*Mobile|Windows.*Phone/.test(navigator.userAgent) ) {
        $(".switch_screen").show();
        if ($.cookie("switch_screen")) {
            mode = $.cookie("switch_screen");
        } else {
            mode = "sp";
        }
        if (mode == "pc") {
            $('meta[name="viewport"]').attr('content', 'width=1024');
            $('.sp_screen').show();
        } else {
            $('.pc_screen').show();
        }
    }
});



// WEBPACK FOOTER //
// ./src/smartphone.js